var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex } from '@syncfusion/ej2-base';
/**
 * Objects used to configure the properties of iframe resources.
 */
export class Resources extends ChildProperty {
}
__decorate([
    Property([])
], Resources.prototype, "styles", void 0);
__decorate([
    Property([])
], Resources.prototype, "scripts", void 0);
/**
 * Configures the iframe settings for the Rich Text Editor.
 */
export class IFrameSettings extends ChildProperty {
}
__decorate([
    Property(false)
], IFrameSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], IFrameSettings.prototype, "attributes", void 0);
__decorate([
    Complex({}, Resources)
], IFrameSettings.prototype, "resources", void 0);
__decorate([
    Property([])
], IFrameSettings.prototype, "metaTags", void 0);
__decorate([
    Property(null)
], IFrameSettings.prototype, "sandbox", void 0);
